import objectHash from "object-hash";
import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { selectCurrentReport } from "../../../../store/selectors/currentReportSelectors";
import {
  selectSelectedDimensionNames,
  selectSelectedMeasureNames,
} from "../../../../store/selectors/fieldsStateSelectors";

const useDimensionAndMeasuresSelection = () => {
  const currentReport = useSelector(selectCurrentReport);
  const storedDimensionNames = useSelector(selectSelectedDimensionNames);
  const storedMeasureNames = useSelector(selectSelectedMeasureNames);
  const storedDimensionNamesRef = useRef(storedDimensionNames);
  storedDimensionNamesRef.current = storedDimensionNames;
  const storedMeasureNamesRef = useRef(storedMeasureNames);
  storedMeasureNamesRef.current = storedMeasureNames;

  const dimensionNamesHash = objectHash(storedDimensionNames ?? []);
  const measureNamesHash = objectHash(storedMeasureNames ?? []);

  const { dimensionNames, measureNames } = useMemo((): { dimensionNames: string[]; measureNames: string[] } => {
    return {
      dimensionNames: storedDimensionNamesRef.current ?? [],
      measureNames: storedMeasureNamesRef.current ?? [],
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentReport?.configuration,
    currentReport?.reportType,
    //Is used to trigger calling getCurrentReportConfigurationAsync when the fields are updated
    dimensionNamesHash,
    measureNamesHash,
  ]);

  return { dimensionNames, measureNames };
};

export default useDimensionAndMeasuresSelection;
